import React from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import AudioSetup from '../components/AudioSetup';
import Footer from './Footer';

export default function Main({ mobileGuide }) {
    return (
        <>
            <Outlet/>
            { mobileGuide && (<Footer/>) }
            <ScrollRestoration/>
            <AudioSetup/>
        </>
    );
}
